export default function CtaSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20banner%20of%20a%20night%20sky%20full%20of%20glowing%20petals%20drifting%20over%20a%20quiet%20city%20skyline%2C%20painterly%20soft%20shading%2C%20deep%20rose%20and%20warm%20amber%20palette%2C%20cinematic%20wide%20illustration%2C%20no%20text&width=1920&height=720&seq=anime-cta-banner&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/60 to-foreground-950/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-background-50">
            挑一部作品，今晚就开始
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
            回到作品浏览区，按题材或关键词锁定目标，再对照更新时间表安排观看节奏。高清、免费、全集与无广告，都在同一页里。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#browse"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line text-lg"></i>
              去浏览作品
            </a>
            <a
              href="#schedule"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap transition-colors hover:bg-background-50/10"
            >
              <i className="ri-calendar-2-line text-lg"></i>
              查看更新时间表
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}